import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import IncomingStatisticsModal from "../../../../modal/PC/purchase/IncomingStatisticsModal";
import GridNoRow from '../../../../common/GridNoRow';
import Checkbox from "../../../../common/Checkbox";
import Moment from 'moment';
import "moment/locale/ko";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useLocation } from "react-router-dom";

const IncomingStatistics = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('1');
    const [gridWidth, setGridWidth] = useState('600px');
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD()
    });
    const [selectDataID, setSelectDataID] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [graphTitle, setGraphTitle] = useState('');
    const [dataKey, setDataKey] = useState('');
    const [isDetailModalOpen, setDetailModalOpen] = useState(false);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        partner_name: true,
        partner_number: true,
        partner_ceo: true,
        total_price_sum: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
        var nextKeyword = null;
        if(tabID === ""){
            setTabID("1");
            return;
        }

        if(tabID === "1" || tabID === "2"){
            nextKeyword = {
                ...keyword,
                ["start_date"] : Moment().format("YYYY-MM-01"),
                ["end_date"] : appStore.YYYY_MM_DD()
            };

            if(tabID === "1"){
                setColumns([
                    {
                        field: 'viewer',
                        headerName: '상세',
                        width: 55,
                        type:'actions',
                        disableClickEventBubbling: true,
                        getActions: (params) => [
                            <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Viewer" />
                        ],
                        headerAlign: 'center', 
                        align:'center'
                    },
                    { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
                    { field: 'partner_name', headerName: '입고처', width: 220, headerAlign: 'center', align:'left'},
                    { field: 'partner_ceo', headerName: '대표자', width: 140, headerAlign: 'center', align:'center' },
                    { field: 'total_count_sum', headerName: '입고수량', width: 100, headerAlign: 'center', align:'right' }
                ]);
            }else if(tabID === "2"){
                setColumns([
                    {
                        field: 'viewer',
                        headerName: '상세',
                        width: 55,
                        type:'actions',
                        disableClickEventBubbling: true,
                        getActions: (params) => [
                            <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Edit" />
                        ],
                        headerAlign: 'center', 
                        align:'center'
                    },
                    { field: 'id', headerName: 'item_id', width: 0, headerAlign: 'center', align:'center' },
                    { field: 'item_name', headerName: '품목명', width: 150, headerAlign: 'center', align:'left' },
                    { field: 'item_total_spec', headerName: '규격', width: 210, headerAlign: 'center', align:'left' },
                    { field: 'total_count_sum', headerName: '입고수량', width: 100, headerAlign: 'center', align:'right' }
                ]);
            }
        }else{
            
            setColumns([
                {
                    field: 'viewer',
                    headerName: '상세',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Edit" />
                    ],
                    headerAlign: 'center', 
                    align:'center'
                },
                { field: 'id', headerName: 'incoming_date', width: 0, headerAlign: 'center', align:'center' },
                { field: 'incoming_date', headerName: '기준', width: 150, headerAlign: 'center', align:'center'},
                { field: 'total_count_sum', headerName: '입고수량', width: 150, headerAlign: 'center', align:'right' }
            ]);

            if(tabID === "3"){
                nextKeyword = {
                    ...keyword,
                    ["start_date"] : Moment().format("YYYY-MM-01"),
                    ["end_date"] : appStore.YYYY_MM_DD()
                };
            }else if(tabID === "4"){
                nextKeyword = {
                    ...keyword,
                    ["start_date"] : Moment().format("YYYY-01-01"),
                    ["end_date"] : appStore.YYYY_MM_DD()
                };
            }
        }

        if(nextKeyword.start_date === keyword.start_date && nextKeyword.end_date === keyword.end_date){
            handleView();
        }else{
            setKeyword(nextKeyword);
        }

        if(tabID === "1" || tabID === "2"){
            setGridWidth('550px')
        }else if(tabID === "3" || tabID === "4"){
            setGridWidth('400px')
        }
    }, [tabID]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.start_date, keyword.end_date])
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
        }
    }, [MenuID])

    const handleInit = () => {
        setTabID('');
    };

    // Grid 데이터 조회
    const handleView = () => {
        if(keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date <= '2049-12-31' && keyword.end_date <= '2049-12-31'){
            setGraphData([])
            setRows([])
            
            if(tabID === '1' || tabID === '2'){
                axios.get('/api/p/IncomingStatistics/List',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '1')?'1':'2'
                    }
                },
                { withCredentials: true }
                )
                .then((response) => { // originrow 저장
                    setOriginRows(response.data);
                })
                .catch((error) => {
                    appStore.capture();
                });

                axios.get('/api/p/IncomingStatistics/Graph',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '1')?'1':'2'
                    }
                },
                { withCredentials: true }
                )
                .then((response) => {
                    if(tabID === '1'){ // 입고처
                        var array = response.data.map((item, index) => ({
                            id: item.partner_id,
                            partner_name: item.partner_name,
                            partner_number: item.partner_number,
                            partner_ceo: item.partner_ceo,
                            total_count_sum: item.total_count_sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        }));
                        array = array.filter((element) => element.total_count_sum !== "0");
                        setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
                        setGraphTitle('입고처별 입고 총량');

                        let temp_array = []
                        for(let i = 0; i < array.length; i++) {
                            var temp_data = ''
                            setDataKey('수량');
                            temp_data = array[i].total_count_sum
                            let temp_row = {name: array[i].partner_name, 수량: Number(temp_data.replaceAll(",",""))}
                            temp_array = temp_array.concat(temp_row)
                        }
                        setGraphData(temp_array);
                    } else if (tabID === '2') { // 품목
                        var array = response.data.map((item, index) => ({
                            id: item.item_id,
                            item_name: item.item_name,
                            item_spec: item.item_spec,
                            item_width: item.item_width,
                            item_depth: item.item_depth,
                            item_height: item.item_height,
                            item_total_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
                            total_count_sum: item.total_count_sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        }));
                        array = array.filter((element) => element.total_count_sum !== "0");
                        setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
                        setGraphTitle('품목별 입고 총량');

                        let temp_array = []
                        for(let i = 0; i < array.length; i++) {
                            var temp_data = ''
                            setDataKey('수량');
                            temp_data = array[i].total_count_sum
                            let temp_row = {name: array[i].item_name, 수량: Number(temp_data.replaceAll(",",""))}
                            temp_array = temp_array.concat(temp_row)
                        }
                        setGraphData(temp_array);
                    }
                })
                .catch((error) => {
                    appStore.capture();
                });
            }else if(tabID === '3' || tabID === '4'){
                axios.get('/api/p/IncomingStatistics/DateList',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '3')?'1':'2'
                    }
                    },
                    { withCredentials: true }
                )
                .then((response) => { // originrow 저장
                    setOriginRows(response.data);
                })
                .catch((error) => {
                    appStore.capture();
                });

                // 그래프 데이터 검색
                axios.get('/api/p/IncomingStatistics/DateGraph',
                    {
                    params : {
                        start_date : keyword.start_date,
                        end_date : keyword.end_date,
                        status : (tabID === '3')?'1':'2'
                    }
                },
                { withCredentials: true }
                )
                .then((response) => {
                    var array = response.data.map((item, index) => ({
                        id: item.incoming_date,
                        incoming_date: item.incoming_date,
                        total_count_sum: item.total_count_sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    }));
                    array = array.filter((element) => element.total_count_sum !== "0");
                    setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));

                    if(tabID === '3'){ // 일별
                        setGraphTitle('일별 입고 총량');
                    } else if (tabID === '4') { // 월별
                        setGraphTitle('월별 입고 총량');
                    }

                    let temp_array = []
                    for(let i = 0; i < array.length; i++) {
                        var temp_data = ''
                        setDataKey('수량');
                        temp_data = array[i].total_count_sum
                        let temp_row = {name: array[i].incoming_date, 수량: Number(temp_data.replaceAll(",",""))}
                        temp_array = temp_array.concat(temp_row)
                    }
                    setGraphData(temp_array);
                })
                .catch((error) => {
                    appStore.capture();
                });
            }
        }
    }

    const onDateChange = (e)=>{
    
        var dateType = 'N'
        var tempStartDate = ''
        var tempEndDate = ''

        if (e.target.name === 'start_date'){
            if(Moment(e.target.value).diff(Moment(keyword.end_date),'days') > 0){
                //시작일자를 마지막일자보다 크게 할 경우 마지막일자를 시작일자로 수정
                dateType = 'U'
            }
        } else if (e.target.name === 'end_date'){
            if(Moment(e.target.value).diff(Moment(keyword.start_date),'days') < 0){
                //마지막일자를 시작일자보다 작게 할 경우 시작일자를 마지막일자로 수정
                dateType = 'U'
            }
        } else {
            if((e.target.name === 'start_date' && Moment(e.target.value) > Moment(keyword.end_date))
            || (e.target.name === 'end_date' && Moment(keyword.start_date) > Moment(e.target.value))){
                dateType = 'U'
            }
        }

        if((tabID === '3')){ // 일별
            if (e.target.name === 'start_date'){
                if(Moment(e.target.value).diff(Moment(keyword.end_date),'days') < -31){
                    //시작일자를 1달 이전으로 설정 할 경우 마지막일자를 시작일자와 한달차이로 앞으로 당겨옴 
                    dateType = 'D'
                    tempStartDate = e.target.value
                    tempEndDate = Moment(e.target.value).add("1","M").add("-1","d").format("YYYY-MM-DD"); 
                }
            } else if (e.target.name === 'end_date'){
                if(Moment(e.target.value).diff(Moment(keyword.start_date),'days') > 31){
                    //마지막일자를 1달 이후로 설정 할 경우 시작일자를 마지막일자와 한달차이로 당겨옴 
                    dateType = 'D'
                    tempStartDate = Moment(e.target.value).add("-1","M").add("1","d").format("YYYY-MM-DD"); 
                    tempEndDate = e.target.value
                }
            }
        } else if(tabID === '4') { // 월별
            if (e.target.name === 'start_date'){
                if(Moment(e.target.value).diff(Moment(keyword.end_date),'month') < -12){
                    //시작일자를 1년 이전으로 설정 할 경우 마지막일자를 시작일자와 1년차이로 당겨옴 
                    dateType = 'M'
                    tempStartDate = e.target.value
                    tempEndDate = Moment(e.target.value).add("1","Y").format("YYYY-MM-DD"); 
                }
            } else if (e.target.name === 'end_date'){
                if(Moment(e.target.value).diff(Moment(keyword.start_date),'month') > 12){
                    //마지막일자를 1년 이후로 설정 할 경우 시작일자를 마지막일자와 1년차이로 당겨옴 
                    dateType = 'M'
                    tempStartDate = Moment(e.target.value).add("-1","Y").format("YYYY-MM-DD"); 
                    tempEndDate = e.target.value
                }
            }
        }

        if (dateType === 'U') {
            const {name, value} = e.target;
            var startDate = '';
            var endDate = '';
            var nextKeyword = {
                ...keyword,
                ['start_date']: value, 
                ['end_date']: value, 
            };

            if(e.target.name === 'start_date'){
                            
                if((((new Date()).toISOString()).substr(0, 10) < value) || (Moment(e.target.value) > Moment(keyword.end_date))){
                    //시작일자 변경 시 : 시작일자가 현재일자 보다 높으면 기본값셋팅(일별 : 시작-현재01일 / 월별 : 시작-현재01월01일 / 종료-현재일자)
                    //console.log('시작일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === '1' || tabID === '2' || tabID === '3'){
                        startDate = ((new Date()).toISOString()).substr(0, 8)+'01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }else if(tabID === '4'){
                        startDate = ((new Date()).toISOString()).substr(0, 5)+'01-01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }
                }else if(((new Date()).toISOString()).substr(0, 10) >= value){
                    //console.log('시작일자가 현재일자 보다 낮거나 같으면 기본값셋팅');
                    
                    if(tabID === '1' || tabID === '2' || tabID === '3'){
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(일별 : 시작일자+31)중 일별 종료일자가 현재일자 보다 낮으면 종료일자셋팅값으로 설정
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(일별 : 시작일자+31)중 일별 종료일자가 현재일자 보다 높으면 오늘일자로 설정
                        startDate = value;
                        if(Moment(value).add("1","M").add("-1","d").format("YYYY-MM-DD") <= ((new Date()).toISOString()).substr(0, 10)){
                            endDate = Moment(value).add("1","M").add("-1","d").format("YYYY-MM-DD"); 
                        }else{
                            endDate = ((new Date()).toISOString()).substr(0, 10);
                        }
                    }else if(tabID === '4'){
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(월별 : 시작년도의말일)중 월별 종료일자가 현재일자 보다 낮으면 종료일자셋팅값으로 설정
                        // 시작일자 변경 시 : 시작일자가 현재일자 보다 낮거나 같으면 -> 종료일자셋팅값(월별 : 시작년도의말일)중 월별 종료일자가 현재일자 보다 높으면 오늘일자로 설정
                        if(Moment(value).format("YYYY-12-31") <= ((new Date()).toISOString()).substr(0, 10)){
                            endDate = Moment(value).format("YYYY-12-31"); 
                        }else{
                            endDate = ((new Date()).toISOString()).substr(0, 10);
                        }
                    }
                }

            } else if (e.target.name === 'end_date'){
                
                if((((new Date()).toISOString()).substr(0, 10) < value) || (Moment(keyword.start_date) > Moment(e.target.value))){
                    //종료일자 변경 시 : 종료일자가 현재일자 보다 높으면 기본값셋팅(일별 : 시작-현재01일 / 월별 : 시작-현재01월01일 / 종료-현재일자)
                    //console.log('종료일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === '1' || tabID === '2' || tabID === '3'){
                        startDate = ((new Date()).toISOString()).substr(0, 8)+'01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }else if(tabID === '4'){
                        startDate = ((new Date()).toISOString()).substr(0, 5)+'01-01';
                        endDate = ((new Date()).toISOString()).substr(0, 10);
                    }
                }else if(((new Date()).toISOString()).substr(0, 10) >= value){
                    //종료일자 변경 시 : 종료일자가 현재일자 보다 낮거나 같으면 -> 시작일자셋팅값(일별 : 월초  / 월별 : 년초)
                    //console.log('종료일자가 현재일자 보다 높으면 기본값셋팅');
                    if(tabID === '1' || tabID === '2' || tabID === '3'){
                        startDate = Moment(value).format("YYYY-MM-01");
                    }else if(tabID === '4'){
                        startDate = Moment(value).format("YYYY-01-01");
                    }
                    endDate = value;
                }
            }

            nextKeyword = {
                ...keyword,
                ['start_date']: startDate, 
                ['end_date']: endDate, 
            };

            setKeyword(nextKeyword);
        } else if (dateType === 'N') {
            const {name, value} = e.target;
            const nextKeyword = {
                ...keyword,
                [name]: value, 
            };
            setKeyword(nextKeyword);
        } else if (dateType === 'D') {
            const nextKeyword = {
                ...keyword,
                ['start_date']: tempStartDate, 
                ['end_date']: tempEndDate, 
            };
            setKeyword(nextKeyword);
        } else if (dateType === 'M') {
            const nextKeyword = {
                ...keyword,
                ['start_date']: tempStartDate, 
                ['end_date']: tempEndDate, 
            };
            setKeyword(nextKeyword);
        }

    };

    const DetailClick = (object) => {
        setDetailModalOpen(true);
        setModalTitle('입고통계');
        setSelectDataID(object.row.id);
    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '185px', boxShadow: 'none' } }>
            <div className="menu-action" style={ { height: '55px' } }>
                <div className="menu-title">{ MenuName }</div>
                <div className="menu-button">
                <Button 
                    onClick={ handleInit }
                    className="btn-p"
                    sx={{  
                        m: 1, 
                        fontSize: 15, 
                        color: "white", 
                        borderColor: "black", 
                        backgroundColor: "black",
                        ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                    }} 
                    variant="outlined">
                    초기화
                </Button>
                <Button 
                    onClick={ handleView }
                    className="btn-p"
                    sx={{  
                        m: 1, 
                        fontSize: 15, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                </Button>
                </div>
            </div>
            <TabContext value={tabID}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                    <Tab key={1} label={"입고처"} value={"1"} />
                    <Tab key={2} label={"품목"} value={"2"} />
                    <Tab key={3} label={"일별"} value={"3"} />
                    <Tab key={4} label={"월별"} value={"4"} />
                </TabList>
                </Box>
            </TabContext>
            <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '100px', fontWeight: 'bold' } }>
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                            ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid" style={ { top: '187px' } }>
                <div style={{ float: 'left', width: gridWidth }}>
                    <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 287px)', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                        {isDetailModalOpen && (
                            <IncomingStatisticsModal
                            onClose={() => {
                                setDetailModalOpen(false);
                            }}
                            title={modalTitle}
                            originRows={originRows}
                            selectDataID={selectDataID}
                            keyword={keyword}
                            tabID={tabID}
                            />
                        )}
                    </div>
                </div>
                <div style={{ float: 'right', width: 'calc(100% - ('+gridWidth+' + 50px))', paddingRight:'50px'}}>
                    <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>{graphTitle}</h3>
                    <div style={{ width: '100%', height: 'calc(100vh - 350px)' }}>
                        <ResponsiveContainer>
                            <ComposedChart width={'calc(100% - '+gridWidth+')'} height={'calc(100vh - 350px)'} data={graphData} margin={{ top: 5, right: 5, bottom: 0, left: 50 }}>
                                <CartesianGrid stroke="#f5f5f5" />
                                <XAxis dataKey="name" />
                                <YAxis tickFormatter={tick => { return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }} />
                                <Tooltip formatter={(okay) => new Intl.NumberFormat('ko').format(okay)}  />
                                <Bar dataKey={dataKey} barSize={25} fill="#413ea0" />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default IncomingStatistics;